var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMutedVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_70_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9226 10.2612L18.042 11.3806L19.1615 10.2612C19.2345 10.1855 19.3218 10.1252 19.4184 10.0837C19.515 10.0423 19.6189 10.0204 19.724 10.0195C19.8291 10.0186 19.9334 10.0386 20.0307 10.0784C20.128 10.1182 20.2164 10.177 20.2907 10.2513C20.365 10.3257 20.4238 10.4141 20.4636 10.5114C20.5034 10.6087 20.5234 10.7129 20.5225 10.818C20.5216 10.9231 20.4998 11.027 20.4583 11.1236C20.4168 11.2202 20.3565 11.3075 20.2809 11.3806L19.1615 12.5L20.2809 13.6194C20.4294 13.7678 20.5129 13.9692 20.513 14.1792C20.5131 14.3892 20.4297 14.5907 20.2813 14.7392C20.1328 14.8878 19.9315 14.9713 19.7214 14.9713C19.5114 14.9714 19.31 14.8881 19.1615 14.7396L18.042 13.6194L16.9226 14.7396C16.7741 14.8881 16.5726 14.9714 16.3626 14.9713C16.1526 14.9713 15.9513 14.8878 15.8028 14.7392C15.6544 14.5907 15.571 14.3892 15.5711 14.1792C15.5712 13.9692 15.6547 13.7678 15.8032 13.6194L16.9226 12.5L15.8032 11.3806C15.7276 11.3075 15.6673 11.2202 15.6258 11.1236C15.5843 11.027 15.5625 10.9231 15.5616 10.818C15.5606 10.7129 15.5807 10.6087 15.6205 10.5114C15.6603 10.4141 15.7191 10.3257 15.7934 10.2513C15.8677 10.177 15.9561 10.1182 16.0534 10.0784C16.1507 10.0386 16.255 10.0186 16.3601 10.0195C16.4652 10.0204 16.5691 10.0423 16.6657 10.0837C16.7622 10.1252 16.8496 10.1855 16.9226 10.2612Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.8137V15.0049C5 15.5812 5.47152 16.0527 6.04781 16.0527H9.19126L12.6386 19.5C13.2987 20.1602 14.4303 19.6887 14.4303 18.7561V7.05202C14.4303 6.11946 13.2987 5.64795 12.6386 6.30807L9.19126 9.76586H6.04781C5.47152 9.76586 5 10.2374 5 10.8137Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_70_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMutedVolume);
export default __webpack_public_path__ + "static/media/ic_muted_volume.7749f62f427c824c5ce162b4e3e47ca0.svg";
export { ForwardRef as ReactComponent };